(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'scrolled-past-header');
      this.header.classList.remove('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'scrolled-past-header');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bundle-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bundle-product'))customElements.define('bundle-product',class extends HTMLElement{connectedCallback(){this.limit=Number(this.dataset.limit);this.sources=new Map([...this.querySelectorAll('[data-source]')].map(node=>[node.dataset.handle,node]));this.slots=[...this.querySelectorAll('[data-slot]')];this.hero=this.querySelector('[data-hero]');this.message=this.querySelector('[data-message]');this.add=this.querySelector('[data-add]');this.slots.forEach(slot=>{const select=slot.querySelector('[data-colour]');slot.dataset.current=select.value;select.addEventListener('change',()=>this.changeColour(slot));this.renderSizes(slot)});this.syncOptions();this.renderHero();this.update();this.add?.addEventListener('click',()=>this.addBundle())}changeColour(slot){const select=slot.querySelector('[data-colour]');const duplicate=this.slots.some(other=>other!==slot&&other.querySelector('[data-colour]').value===select.value);if(duplicate){select.value=slot.dataset.current;this.message.textContent=this.dataset.duplicateMessage;return}slot.dataset.current=select.value;slot.dataset.size='';this.message.textContent='';this.renderSizes(slot);this.syncOptions();this.renderHero();this.update()}renderSizes(slot){const source=this.sources.get(slot.dataset.current);const target=slot.querySelector('[data-sizes]');target.replaceChildren();if(!source)return;const variants=[...source.querySelectorAll('[data-variant]')];let selected=variants.find(v=>v.dataset.size===slot.dataset.size&&v.dataset.available==='true');if(!selected)selected=variants.find(v=>v.dataset.available==='true');slot.dataset.size=selected?.dataset.size||'';for(const variant of variants){const button=document.createElement('button');button.type='button';button.className='bundle-product__size';button.textContent=variant.dataset.size;button.disabled=variant.dataset.available!=='true';button.setAttribute('aria-pressed',String(variant.dataset.size===slot.dataset.size));button.addEventListener('click',()=>{slot.dataset.size=variant.dataset.size;target.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));this.update()});target.append(button)}this.update()}syncOptions(){for(const slot of this.slots){const current=slot.querySelector('[data-colour]');const others=new Set(this.slots.filter(other=>other!==slot).map(other=>other.querySelector('[data-colour]').value));for(const option of current.options)option.disabled=others.has(option.value)}}renderHero(){this.hero.replaceChildren();this.hero.style.setProperty('--count',String(this.limit));for(const slot of this.slots){const source=this.sources.get(slot.dataset.current);if(!source?.dataset.image)continue;const card=document.createElement('div');card.className='bundle-product__hero-card';const image=document.createElement('img');image.src=source.dataset.image;image.alt=source.dataset.title;image.loading='eager';card.append(image);this.hero.append(card)}}update(){const complete=this.slots.length===this.limit&&this.slots.every(slot=>slot.dataset.current&&slot.dataset.size);if(this.add)this.add.disabled=!complete;for(const slot of this.slots)slot.querySelector('[data-size-label]').textContent=slot.dataset.size||'';const count=this.slots.filter(slot=>slot.dataset.current).length;const label=this.dataset.selectedTemplate.replace('[selected]',count).replace('[total]',this.limit);const heroCount=this.querySelector('[data-gallery-count]');if(heroCount)heroCount.textContent=label;const actionCount=this.querySelector('.bundle-product__actions p');if(actionCount)actionCount.textContent=label}async addBundle(){if(this.slots.some(slot=>!slot.dataset.size)){this.message.textContent=this.dataset.sizeMessage;return}const properties={};this.slots.forEach((slot,index)=>{properties['Colour '+(index+1)]=this.sources.get(slot.dataset.current).dataset.title;properties['Size '+(index+1)]=slot.dataset.size});this.add.disabled=true;this.add.setAttribute('aria-busy','true');try{const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variantId),quantity:1,properties}]})});if(!response.ok)throw new Error();if(window.drpplyRefreshCartCount)window.drpplyRefreshCartCount().catch(()=>{});this.add.disabled=false;this.add.removeAttribute('aria-busy');const cartLink=[...document.querySelectorAll('a[href="/cart"]')].find(link=>link.getClientRects().length&&getComputedStyle(link).visibility!=='hidden');if(cartLink){const stayOnPage=event=>event.preventDefault();cartLink.addEventListener('click',stayOnPage,true);try{cartLink.click()}finally{cartLink.removeEventListener('click',stayOnPage,true)}}}catch(error){this.message.textContent=this.dataset.errorMessage;this.add.disabled=false;this.add.removeAttribute('aria-busy')}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-perfectly-cropped-bundle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('perfectly-cropped-bundle')) {
  customElements.define('perfectly-cropped-bundle', class extends HTMLElement {
    connectedCallback() {
      this.sources = new Map([...this.querySelectorAll('[data-source]')].map(node => [node.dataset.handle, node]));
      this.slots = [...this.querySelectorAll('[data-slot]')];
      this.hero = this.querySelector('[data-hero]');
      this.message = this.querySelector('[data-message]');
      this.add = this.querySelector('[data-add]');
      this.slots.forEach(slot => {
        const select = slot.querySelector('[data-colour]');
        slot.dataset.current = select.value;
        select.addEventListener('change', () => {
          slot.dataset.current = select.value;
          this.message.textContent = '';
          this.renderSizes(slot);
          this.renderHero();
          this.update();
        });
        this.renderSizes(slot);
      });
      this.update();
      this.add?.addEventListener('click', () => this.addBundle());
    }
    renderSizes(slot) {
      const source = this.sources.get(slot.dataset.current);
      const target = slot.querySelector('[data-sizes]');
      target.replaceChildren();
      if (!source) return;
      const variants = [...source.querySelectorAll('[data-variant]')];
      let selected = variants.find(v => v.dataset.size === slot.dataset.size && v.dataset.available === 'true');
      if (!selected) selected = variants.find(v => v.dataset.available === 'true');
      slot.dataset.size = selected?.dataset.size || '';
      for (const variant of variants) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pc-bundle__size';
        button.textContent = variant.dataset.size;
        button.disabled = variant.dataset.available !== 'true';
        button.setAttribute('aria-pressed', String(variant.dataset.size === slot.dataset.size));
        button.addEventListener('click', () => {
          slot.dataset.size = variant.dataset.size;
          target.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.update();
        });
        target.append(button);
      }
    }
    renderHero() {
      this.hero.replaceChildren();
      for (const slot of this.slots) {
        const source = this.sources.get(slot.dataset.current);
        if (!source?.dataset.image) continue;
        const card = document.createElement('div');
        card.className = 'pc-bundle__hero-card';
        const image = document.createElement('img');
        image.src = source.dataset.image;
        image.alt = source.dataset.title;
        image.loading = 'eager';
        card.append(image);
        this.hero.append(card);
      }
    }
    update() {
      if (this.add) this.add.disabled = this.slots.length !== 3 || this.slots.some(slot => !slot.dataset.current || !slot.dataset.size);
      for (const slot of this.slots) slot.querySelector('[data-size-label]').textContent = slot.dataset.size || '';
    }
    async addBundle() {
      if (this.slots.some(slot => !slot.dataset.size)) {
        this.message.textContent = this.dataset.sizeMessage;
        return;
      }
      const properties = {};
      this.slots.forEach((slot, index) => {
        properties['Colour ' + (index + 1)] = this.sources.get(slot.dataset.current).dataset.title;
        properties['Size ' + (index + 1)] = slot.dataset.size;
      });
      this.add.disabled = true;
      this.add.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(this.dataset.variantId), quantity: 1, properties}]})
        });
        if (!response.ok) throw new Error();
        if (window.drpplyRefreshCartCount) window.drpplyRefreshCartCount().catch(() => {});
        const cartLink = [...document.querySelectorAll('a[href="/cart"]')].find(link => link.getClientRects().length && getComputedStyle(link).visibility !== 'hidden');
        if (cartLink) {
          const stayOnPage = event => event.preventDefault();
          cartLink.addEventListener('click', stayOnPage, true);
          try { cartLink.click(); } finally { cartLink.removeEventListener('click', stayOnPage, true); }
        }
      } catch (error) {
        this.message.textContent = this.dataset.errorMessage;
      } finally {
        this.add.removeAttribute('aria-busy');
        this.update();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-bundle-builder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('premium-bundle-builder'))customElements.define('premium-bundle-builder',class extends HTMLElement{connectedCallback(){this.limit=2;this.selected=[];this.tiers=[...this.querySelectorAll('[data-count]')];this.cards=[...this.querySelectorAll('[data-card]')];this.count=this.querySelector('[data-selection-count]');this.message=this.querySelector('[data-message]');this.total=this.querySelector('[data-total]');this.add=this.querySelector('[data-add]');this.tiers.forEach(t=>t.addEventListener('click',()=>this.setTier(t)));this.cards.forEach(c=>{c.querySelector('[data-toggle]').addEventListener('click',()=>this.toggle(c));c.querySelector('[data-variant]').addEventListener('change',()=>this.update())});this.add?.addEventListener('click',()=>this.addBundle());this.update()}setTier(t){this.limit=Number(t.dataset.count);this.tiers.forEach(x=>{let active=x===t;x.classList.toggle('is-active',active);x.setAttribute('aria-checked',String(active))});while(this.selected.length>this.limit)this.deselect(this.selected.at(-1));this.message.textContent='';this.update()}toggle(c){if(c.classList.contains('is-selected'))this.deselect(c);else if(this.selected.length<this.limit){this.selected.push(c);c.classList.add('is-selected');c.querySelector('[data-toggle]').setAttribute('aria-pressed','true');c.querySelector('[data-variant]').disabled=false}else this.message.textContent=this.dataset.limitMessage.replace('[count]',this.limit);this.update()}deselect(c){this.selected=this.selected.filter(x=>x!==c);c.classList.remove('is-selected');c.querySelector('[data-toggle]').setAttribute('aria-pressed','false');let s=c.querySelector('[data-variant]');s.disabled=true;s.value=''}update(){this.selected.forEach((c,i)=>c.querySelector('[data-order]').textContent=i+1);this.count.textContent=this.dataset.selectedTemplate.replace('[selected]',this.selected.length).replace('[total]',this.limit);let complete=this.selected.length===this.limit&&this.selected.every(c=>c.querySelector('[data-variant]').value);this.add.disabled=!complete;let cents=this.selected.reduce((sum,c)=>sum+Number(c.querySelector('[data-variant]').selectedOptions[0]?.dataset.price||0),0);this.total.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(cents/100);if(this.selected.length<this.limit)this.message.textContent=''}async addBundle(){if(this.selected.some(c=>!c.querySelector('[data-variant]').value)){this.message.textContent=this.dataset.sizeMessage;return}let tier=this.tiers.find(t=>t.classList.contains('is-active'));let items=this.selected.map(c=>({id:Number(c.querySelector('[data-variant]').value),quantity:1,properties:{Bundle:tier.dataset.label}}));this.add.disabled=true;this.add.setAttribute('aria-busy','true');try{let response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});if(!response.ok)throw new Error();window.location.assign(this.dataset.cartUrl)}catch(error){this.message.textContent=this.dataset.errorMessage;this.add.disabled=false;this.add.removeAttribute('aria-busy')}}});

  } catch(e) { console.error(e); }
})();
})();
